<div style="background: #F5F5F5; padding: 16px;" [ngClass]="{'view-strategy-info': viewOnly}">
  <div class="page-title-bar d-flex flex-row mb-3 strategy-title-bar mb-2">
    <div class="title mt-1 title-ellipsis" style="width: 85%">
      {{taxStrategy.name || ''}}
    </div>
    <div style="width: 15%">
      <ng-template [ngIf]="!viewOnly">
        <span class="float-right pointer strategy-edit-icon" (click)="openEditStrategy()">
          <span><i class="material-icons">edit</i></span>
          <span>Edit</span>
        </span>
          <span class="float-right pointer compose-post strategy-archive" (click)="archiveStrategy()">
          <span class="label-text">Archive</span>
        </span>
      </ng-template>
    </div>
  </div>
  <div class="row" style="padding: 15px;">
    <div class="medium-12">
      <div class="tax-strategy">
        <div foundation class="reports">
          <div class="row">
            <div class="medium-12 columns" style="padding: 0;">
              <ul class="reports tabs" data-tabs id="report-tabs" style="background: #F5F5F5;padding: 0;">
                <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'overview'}"><a id="a-overview"(click)="switchPage('overview')" aria-selected="false"><h6>Overview</h6></a></li>
                <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'internal'}"><a id="a-internal" (click)="switchPage('internal')" aria-selected="false"><h6>Internal</h6></a></li>
                <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'resources'}"><a id="a-resources" (click)="switchPage('resources')" aria-selected="false"><h6>Resources</h6></a></li>
                <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'tasks'}"><a id="a-tasks" (click)="switchPage('tasks')" aria-selected="false"><h6>Tasks</h6></a></li>
                <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'templates'}"><a id="a-templates" (click)="switchPage('templates')" aria-selected="false"><h6>Templates</h6></a></li>
                <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'vendors'}"><a id="a-vendors" (click)="switchPage('vendors')" aria-selected="false"><h6>Preferred Vendors</h6></a></li>
                <li class="reports tabs-title" *ngIf="isRulesEnabled" [ngClass]="{'is-active': currentView == 'rules'}"><a id="a-rules" (click)="switchPage('rules')" aria-selected="false"><h6>Rules</h6></a></li>
              </ul>
            </div>
          </div>
          <div class="reports" data-tabs-content="report-tabs">
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'overview'" id="overview">
              <app-tax-strategy-overview [taxStrategy]="getOverviewTaxStrategy()"></app-tax-strategy-overview>
            </div>
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'internal'" id="internal">
              <app-tax-strategy-internal [taxStrategy]="taxStrategy"></app-tax-strategy-internal>
            </div>
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'resources'" id="resources">
              <app-tax-strategy-resources [taxStrategy]="taxStrategy"></app-tax-strategy-resources>
            </div>
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'tasks'" id="tasks">
              <app-tax-strategy-tasks [taxStrategy]="taxStrategy" [checklist]="checklist" [recurringChecklists]="recurringChecklists"></app-tax-strategy-tasks>
            </div>
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'templates'" id="templates">
              <ng-template [ngIf]="showTemplates">
                <div class="template-disclamer mb-3">
                  <span class="head">Note : </span>
                  <span class="text"> To edit, navigate to the templates in your left hand navigation window. To apply to a client, go into your client's tax plan, then select the "template" icon in the top right to choose. Want more templates? Let us know in the feedback.</span>
                </div>
                <app-templates-list [strategyId]="taxStrategyId" [strategyMode]="mode" [templates]="taxStrategy.templates" (triggerRefreshOnUpdateTemplate)="triggerRefreshOnUpdateTemplate()"></app-templates-list>
              </ng-template>
            </div>
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'vendors'" id="vendors">
              <ng-template [ngIf]="showVendors">
                <app-strategy-preferred-vendors [strategy]="taxStrategy" [strategyVendors]="taxStrategy.vendors"></app-strategy-preferred-vendors>
              </ng-template>
            </div>
            <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'rules' && isRulesEnabled" id="rules">
              <ng-container *ngIf="!isEditable; else rulesEditTemplate">
                <div class="row">
                  <div class="medium-6 columns">
                    <label class="strategy-view-label">Formula</label>
                    <div class="strategy-view-content">{{taxStrategy.rules?.formula || '—'}}</div>
                  </div>
                  <div class="medium-6 columns">
                    <label class="strategy-view-label">Plan Amount Formula</label>
                    <div class="strategy-view-content">{{taxStrategy.rules?.planAmountFormula || '—'}}</div>
                  </div>
                  <div class="medium-12 columns margin-top-20">
                    <label class="strategy-view-label">Why Description</label>
                    <div class="strategy-view-content" [innerHTML]="taxStrategy.rules?.whyDescription || '—'"></div>
                  </div>
                  <div class="medium-12 columns margin-top-20">
                    <label class="strategy-view-label">Plan Amount Description</label>
                    <div class="strategy-view-content" [innerHTML]="taxStrategy.rules?.fieldDescription || '—'"></div>
                  </div>

                  <div class="medium-12 columns margin-top-20">
                    <div class="discovery-ai-section">
                      <div class="discovery-ai-section-title">Discovery AI Fields</div>
                      <div class="row">
                        <div class="medium-6 columns">
                          <label class="strategy-view-label">AI Q JSON Field</label>
                          <div class="strategy-view-content discovery-ai-value">{{taxStrategy.rules?.aiQJsonField || '—'}}</div>
                        </div>
                        <div class="medium-6 columns">
                          <label class="strategy-view-label">AI Q Category
                            <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
                              <i class="icon ion-ios-information-outline info-icon" style="font-size: 15px; color: #475467;"></i>
                              <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 260px !important; line-height: 1.35;">
                                Category: Updating this will update the Category of the Strategy.
                              </span>
                            </span>
                          </label>
                          <div class="strategy-view-content discovery-ai-value">{{taxStrategy.rules?.aiQCategory || '—'}}</div>
                        </div>
                        <div class="medium-6 columns margin-top-20">
                          <label class="strategy-view-label">AI Q Gate</label>
                          <div class="strategy-view-content discovery-ai-value">{{taxStrategy.rules?.aiQGate || '—'}}</div>
                        </div>
                        <div class="medium-6 columns margin-top-20">
                          <label class="strategy-view-label">AI Q Gate Title</label>
                          <div class="strategy-view-content discovery-ai-value">{{taxStrategy.rules?.aiQGateTitle || '—'}}</div>
                        </div>
                        <div class="medium-6 columns margin-top-20">
                          <label class="strategy-view-label">AI Q Discovery Question</label>
                          <div class="strategy-view-content discovery-ai-value">{{taxStrategy.rules?.aiQDiscoveryQuestion || '—'}}</div>
                        </div>
                        <div class="medium-6 columns margin-top-20">
                          <label class="strategy-view-label">AI Q Min Risk
                            <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
                              <i class="icon ion-ios-information-outline info-icon" style="font-size: 15px; color: #475467;"></i>
                              <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 320px !important; line-height: 1.35;">
                                Risk: Updating this will update the Risk of the Strategy, not the Discovery Fields.
                              </span>
                            </span>
                          </label>
                          <div class="strategy-view-content discovery-ai-value">{{taxStrategy.rules?.aiQMinRisk || '—'}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row edit-actions-row">
                  <div class="medium-12 columns text-right">
                    <button class="button small edit-action-btn" (click)="enableEdit()">Edit</button>
                  </div>
                </div>
              </ng-container>
              <ng-template #rulesEditTemplate>
                <div class="row">
                  <div class="medium-6 columns">
                    <label class="strategy-view-label">Formula</label>
                    <textarea rows="3" class="strategy-view-content" [(ngModel)]="taxStrategy.rules.formula"></textarea>
                  </div>
                  <div class="medium-6 columns">
                    <label class="strategy-view-label">Plan Amount Formula</label>
                    <textarea rows="3" class="strategy-view-content" [(ngModel)]="taxStrategy.rules.planAmountFormula"></textarea>
                  </div>
                  <div class="medium-12 columns margin-top-20">
                    <label class="strategy-view-label">Why Description</label>
                    <textarea rows="3" class="strategy-view-content" [(ngModel)]="taxStrategy.rules.whyDescription"></textarea>
                  </div>
                  <div class="medium-12 columns margin-top-20">
                    <label class="strategy-view-label">Plan Amount Description</label>
                    <textarea rows="3" class="strategy-view-content" [(ngModel)]="taxStrategy.rules.fieldDescription"></textarea>
                  </div>

                  <div class="medium-12 columns margin-top-20">
                    <div class="discovery-ai-section">
                      <div class="discovery-ai-section-title">Discovery AI Fields</div>
                      <div class="row">
                        <div class="medium-6 columns">
                          <label class="strategy-view-label">AI Q JSON Field</label>
                          <textarea rows="2" class="strategy-view-content discovery-ai-textarea" [(ngModel)]="taxStrategy.rules.aiQJsonField"></textarea>
                        </div>
                        <div class="medium-6 columns">
                          <label class="strategy-view-label">AI Q Category
                            <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
                              <i class="icon ion-ios-information-outline info-icon" style="font-size: 15px; color: #475467;"></i>
                              <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 260px !important; line-height: 1.35;">
                                Category: Updating this will update the Category of the Strategy.
                              </span>
                            </span>
                          </label>
                          <select class="strategy-view-content discovery-ai-select" [(ngModel)]="taxStrategy.rules.aiQCategory">
                            <option value="">Select category</option>
                            <option *ngFor="let category of stratagiesTypes" [value]="category.type">{{category.type}}</option>
                          </select>
                        </div>
                        <div class="medium-6 columns margin-top-20">
                          <label class="strategy-view-label">AI Q Gate</label>
                          <textarea rows="2" class="strategy-view-content discovery-ai-textarea" [(ngModel)]="taxStrategy.rules.aiQGate"></textarea>
                        </div>
                        <div class="medium-6 columns margin-top-20">
                          <label class="strategy-view-label">AI Q Gate Title</label>
                          <textarea rows="2" class="strategy-view-content discovery-ai-textarea" [(ngModel)]="taxStrategy.rules.aiQGateTitle"></textarea>
                        </div>
                        <div class="medium-6 columns margin-top-20">
                          <label class="strategy-view-label">AI Q Discovery Question</label>
                          <textarea rows="2" class="strategy-view-content discovery-ai-textarea" [(ngModel)]="taxStrategy.rules.aiQDiscoveryQuestion"></textarea>
                        </div>
                        <div class="medium-6 columns margin-top-20">
                          <label class="strategy-view-label">AI Q Min Risk
                            <span class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
                              <i class="icon ion-ios-information-outline info-icon" style="font-size: 15px; color: #475467;"></i>
                              <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 320px !important; line-height: 1.35;">
                                Risk: Updating this will update the Risk of the Strategy, not the Discovery Fields.
                              </span>
                            </span>
                          </label>
                          <select class="strategy-view-content discovery-ai-select" [(ngModel)]="taxStrategy.rules.aiQMinRisk">
                            <option value="">Select risk</option>
                            <option *ngFor="let risk of aiQRiskLevels" [value]="risk.value">{{risk.key}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row edit-actions-row">
                  <div class="medium-12 columns text-right">
                    <button class="button small edit-action-btn" (click)="saveRules()">Save</button>
                    <button class="button small cancel-button edit-action-btn" [disabled]="!isEditable" (click)="cancelEdit()">Cancel</button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="reveal['editStrategy']">
    <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['editStrategy']}">
    </div>
    <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 75%;" [ngClass]="{'tpiq-reveal': reveal['editStrategy']}">
      <div class="body" style="padding: 15px;height: 90vh;">
        <app-create-or-update-strategy [editMode]="true" [taxStrategyId]="taxStrategyId" (onCreateOrUpdateStrategy)="refreshStrategy()" (onCancelCreationOfStrategy)="hideReveal('editStrategy')"></app-create-or-update-strategy>
      </div>
    </div>
  </div>
</div>
